<script>
import { BModal } from 'bootstrap-vue'
import Changes from "@core/components/common/changelog/Changes.vue";

export default {
    name: 'ChangesModal',
    components: {Changes, BModal},
    props: {
        label: {
            default() {
                return this.$t('Component(ChangeLog):changes-label')
            }
        },
        changes: {
            required: true,
            default() {
                return [];
            }
        }
    },
    methods: {
        show() {
            this.$refs['changes-modal'].show();
        }
    }
}
</script>

<template>
    <b-modal
        ref="changes-modal"
        cancel-variant="outline-secondary"
        body-class="p-0"
        size="xl"
        hide-header
        :ok-title="$t('Component(Button):close')"
        centered
        ok-only
    >
        <Changes
            :changes="changes"
            :label="label"
        />
    </b-modal>
</template>
